<template>
  <v-container>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <ClarionDateControl class="input-text-size"
                        :isRequired="false" :isIsoDate="true" :isToggle="false"
                        label="Apportionment From Date" v-model="editedItem.axFromDate"/>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="5">
                  <ClarionDateControl class="input-text-size"
                        :isRequired="false" :isIsoDate="true" :isToggle="false"
                        label="Apportionment To Date" v-model="editedItem.axToDate"/>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <ClarionDateControl class="input-text-size"
                        :isRequired="false" :isIsoDate="true" :isToggle="false"
                        label="Warrant Date" v-model="editedItem.warrantDate"/>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="Warrant Number" v-model="editedItem.warrant"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Unit Fund" v-model="editedItem.unitFund"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Fund Description" v-model="editedItem.taxDesc"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense
                  hide-details label="Source Number" v-model="editedItem.source"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  label="Source Description"
                  hide-details v-model="editedItem.sourceDesc"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Tax Unit" v-model="editedItem.taxUnit"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense
                  label="Unit Description"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details v-model="editedItem.taxDesc"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense
                  hide-details label="unit Details"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense
                  label="Amount"
                  hide-details v-model="editedItem.amount"
                  @blur="roundAmount('amount')"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-checkbox dense v-model="editedItem.warrantsCreated"
                  hide-details label="Warrants Created"></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox dense v-model="editedItem.isLocked"
                  hide-details label="Locked"></v-checkbox>
                </v-col>
              </v-row>
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import ClarionDateControl from '../common/ClarionDateControl.vue';
import '../../assets/style.css';
import { amountFieldsRemit } from './apportionment/apportionmnetUtils';
import { amountFormat, amountToNumber } from '../../util/shared/vue-global';
import GlobalToCaps from '../../util/shared/GlobalToCaps.mixin.vue';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  created() {
  },
  components: {
    ClarionDateControl,
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem || {},
    }),

    editedItem: {
      get() {
        const item = this.item(this.baseCrudKey);
        amountFieldsRemit.forEach((f) => {
          item[f] = amountFormat(amountToNumber(item[f]));
        });
        return item;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    ...mapActions('shared/taxDistrict', [
    ]),
    roundAmount(field) {
      this.editedItem[field] = amountFormat(amountToNumber(this.editedItem[field]));
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}

</style>
